export const createFormState = (data) => {
  return {
    // String or Text Fields
    bankId: data.bankId || undefined,
    bankName: data.bankName || null,
    shortName: data.shortName || null,
    bankCode: data.bankCode || null,
    accountNo: data.accountNo || null,
    micrCode: data.micrCode || null,
    ifsc: data.ifsc || null,
    discription: data.discription || null,
    note: data.note || null,
    gstin: data.gstin || null,
    provisionalGstin: data.provisionalGstin || null,
    bankAddress: data.bankAddress || null,
    locality: data.locality || null,
    bankEmail: data.bankEmail || null,

    // Number Field
    pincode: data.pincode || null,

    // Select/Dropdown Fields (Object with label property)
    city: data.city ? data.city : null,
    area: data.area ? data.area : null,
    region: data.region ? data.region : null,
    country: data.country ? data.country : null,
    zone: data.zone ? data.zone : null,
    branchCode: data.branchCode
      ? data.branchCode.map((item) => item.code)
      : null,
    gstinType: data.gstinType ? data.gstinType?.label : null,
  };
};
